import axios from "@/index";
const brandType = {
  state: {
    brandTypeList: [],
    brandTypeInfoData: [],
    brandTypeOptions: []
  },
  getters: {},
  actions: {
    getBrandTypeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBrandTypeList",
                (state, { brandTypeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBrandTypeById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBrandTypeById",
                (state, { brandTypeInfoData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBrandTypeOptions: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBrandTypeOptions",
                (state, { brandTypeOptions: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setBrandTypeList(state, action) {
      state.brandTypeList = action.brandTypeList;
    },
    setBrandTypeById(state, action) {
      state.brandTypeInfoData = action.brandTypeInfoData;
    },
    setBrandTypeOptions(state, action) {
      state.brandTypeOptions = action.brandTypeOptions;
    }
  }
};
export default brandType;
